<template>
  <div class="rounded-sm bg-surface-elevation-1 px-4 pb-6 shadow-sm">
    <div class="flex gap-4 pt-9">
      <TopRatedBadgeSvg :category="t('Reviews.product.campaign.topRatedBadgeBox.categoryPlaceholder')" :timeframe class="w-1/6 pb-2" />
      <div>
        <div>
          <span
            data-testid="top-rated-badge-status"
            class="mr-1 inline-block h-2 w-2 rounded-full"
            :class="eligible ? 'bg-success-strong' : 'bg-primary-strong'"
          />
          <span class="text-label-m text-subtlest">
            {{ t('Reviews.product.campaign.topRatedBadgeBox.received') }}
          </span>
        </div>
        <div class="mb-2 text-body-s text-subtlest">
          <span class="text-headline-s text-subtle">{{ reviewCount }}</span>
          <span>/{{ minimumReviewCount }} Reviews</span>
          <span v-if="averageScore !== null" class="ml-2">
            {{ t('Reviews.product.campaign.topRatedBadgeBox.averageScore', { score: averageScore.toFixed(1) }) }}
          </span>
        </div>
      </div>
    </div>
    <LinearProgress
      data-testid="top-rated-badge-progress"
      class="mb-6"
      percentage="outside"
      :progress="progress"
      overshoot-style="success"
      :overshoot-threshold="100"
    />
    <div class="flex text-label-m text-subtlest">
      <InfoIcon class="mt-1 mr-1 lucide-icon-xs shrink-0" />
      <div v-html="t('Reviews.product.campaign.topRatedBadgeBox.infoText')" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { LinearProgress } from '@ramp106/omrjs-core-ui'
import { InfoIcon } from '@ramp106/omrjs-core-ui/icons'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import TopRatedBadgeSvg from './TopRatedBadgeSvg.vue'

const props = defineProps<{
  reviewCount: number
  minimumReviewCount: number
  averageScore: number | null
  eligible: boolean
  timeframe: string
}>()

const { t } = useI18n()

const progress = computed(() => (props.eligible ? 100 : Math.min(Math.floor((props.reviewCount / props.minimumReviewCount) * 100), 99)))
</script>
